export const lastfmKeyAndConfig = `&api_key=${process.env.REACT_APP_LASTM_KEY}&format=json`;